import App from './App.vue'
import router from './router'
import { antComponents } from './antd'
import { CommonComponents } from './use-common-components'
import 'virtual:svg-icons-register'
import store, { storeKey } from './store'
import { createInstance } from '/@/root'
import { useDirectives, lazyPlugin, usePermissionPlugin, useModalDirectives } from './directives'
import '/@/styles/index.scss'
import '/@/styles/iconfont.css'
import '/@/assets/icon_font/iconfont.css'
import './utils/rem'
import './permission'
import VueCompareImage from 'vue3-compare-image'
import { loadOfflineConfig } from '/@/utils/map-layer-utils'
import { createApp } from 'vue'

async function bootstrap () {
  await loadOfflineConfig() // ✅ 全局只拉一次

  const app = createInstance(App)
  app.use(store, storeKey)
  app.use(router)
  app.use(CommonComponents)
  app.use(antComponents)
  app.use(useDirectives)
  app.use(useModalDirectives)
  app.use(lazyPlugin)
  app.use(usePermissionPlugin)
  app.use(VueCompareImage)

  app.mount('#demo-app')
}

bootstrap()
